import React from 'react';
import styled from 'styled-components';


const StyledPhoneNumber = styled.a`
  color: ${({ theme }) => theme.colors.lightGray};
  display: block;
  text-decoration: none;
`;

interface CustomPhoneNumberProps {
  phoneNumber: string,
  children: string,
}

const CustomPhoneNumber = ({ phoneNumber, children, ...props }: CustomPhoneNumberProps) => (
  <StyledPhoneNumber
    href={`tel:${phoneNumber}`}
    {...props}
  >
    {children}
  </StyledPhoneNumber>
);

export default CustomPhoneNumber;
